/* hs-eslint ignored failing-rules */
/* eslint-disable hubspot-dev/prefer-hubspot-url-utils */

import { useIsLoggedIn } from '../publicQueries';
import { ThemedPrimaryButton, ThemedSecondaryButton } from '../../../components/ThemedComponents';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const PublicPageAuthButtons = () => {
  const {
    isLoggedIn,
    isLoggedInLoading
  } = useIsLoggedIn();
  if (isLoggedInLoading) {
    return null;
  }
  return isLoggedIn ? /*#__PURE__*/_jsx(ThemedSecondaryButton, {
    href: "https://app.hubspot.com/academy",
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "academyPublic.publicNav.goToAccount"
    })
  }) : /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(ThemedSecondaryButton, {
      href: `https://app.hubspot.com/login?loginRedirectUrl=https%3A%2F%2Fapp.hubspot.com%2Facademy%2F&hubs_signup-url=${encodeURIComponent(window.location.hostname + window.location.pathname)}&hubs_signup-cta=null`,
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "academyPublic.publicNav.logIn"
      })
    }), /*#__PURE__*/_jsx(ThemedPrimaryButton, {
      href: `https://app.hubspot.com/signup-hubspot/academy?hubs_signup-cta=academy-nav&hubs_signup-url=${encodeURIComponent(window.location.hostname + window.location.pathname)}`,
      use: "primary",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "academyPublic.publicNav.signUp"
      })
    })]
  });
};
export default PublicPageAuthButtons;